
import { Component, Input, ChangeDetectionStrategy } from "@angular/core";
import { RouterModule } from "@angular/router";
import { MatIconButton } from "@angular/material/button";
import { MatDivider } from "@angular/material/divider";
import { MatIcon } from "@angular/material/icon";
import { MatMenu, MatMenuItem, MatMenuTrigger } from "@angular/material/menu";
import { MatTooltip } from "@angular/material/tooltip";
import { TranslocoPipe } from "@jsverse/transloco";
import {
  ASSET_SETTINGS_MENU_ITEMS,
  USERS_SETTINGS_MENU_ITEMS,
} from "../loren-sidenav/constants/loren-settings-menu-items.constants";
import { LorenSharedDirectivesModule } from "../../../../../../directives/loren-shared-directives.module";
import { LorenMenuItem } from "../../interfaces/loren-menu-item.interface";
import { TourAnchorMatMenuDirective } from "ngx-ui-tour-md-menu";
import { LorenSidenavTourSteps } from "../../../../../../constants/loren-tour-steps.constants";

@Component({
  selector: "loren-settings-menu",
  imports: [
    RouterModule,
    MatMenu,
    MatMenuItem,
    MatIcon,
    MatIconButton,
    MatDivider,
    MatMenuTrigger,
    MatTooltip,
    TourAnchorMatMenuDirective,
    TranslocoPipe,
    LorenSharedDirectivesModule
],
  templateUrl: "./loren-settings-menu.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./loren-settings-menu.component.scss",
})
export class LorenSettingsMenuComponent {
  @Input() isHandset: boolean;

  readonly settingsAnchorId = LorenSidenavTourSteps.find(
    (x) => x.anchorId === "settings"
  ).anchorId;

  readonly assetSettingsMenuItems: Partial<LorenMenuItem>[] =
    ASSET_SETTINGS_MENU_ITEMS;
  readonly userSettingsMenuItems: Partial<LorenMenuItem>[] =
    USERS_SETTINGS_MENU_ITEMS;
}
